export default __webpack_public_path__ + "static/media/logo-databit.9f5e2fdf.png";